export const LEXICAL_TABLE_MARGIN = {
  left: 50,
  top: 46,
};
